import React, { useState } from 'react';
import { PgHeader } from './ui';

const DOWNLOAD_URL = 'https://github.com/foxsamuel-pro/amonglr/releases/latest/download/AmongLR-Setup.exe';

const FEATURES = [
  { icon: '📊', title: 'Live Overlay',      desc: 'ELO, tokens, and stats while playing' },
  { icon: '🏆', title: 'Post-Game Results', desc: 'Animated ELO changes after each game' },
  { icon: '🚀', title: 'Quick Launch',      desc: 'Launch Among Us directly from the app' },
  { icon: '🌐', title: 'Full Website',      desc: 'Lootboxes, casino, marketplace built in' },
];

function SettingsPage({ user, userData, onIgnSave, onLogout }) {
  const [ignInput, setIgnInput] = useState(userData?.ign || '');
  const [saving, setSaving] = useState(false);

  const ignUnchanged = ignInput.trim() === (userData?.ign || '');
  const canSave = !saving && ignInput.trim() && !ignUnchanged;

  const handleSave = async () => {
    if (!canSave) return;
    setSaving(true);
    try {
      await onIgnSave(ignInput.trim());
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="v2-page">
      <PgHeader title="Settings" sub="Account, overlay, and session" />

      {user && (
        <div className="v2-card" style={{ padding: '20px 22px', marginBottom: 14 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 18 }}>
            <span style={{ fontSize: 22 }}>👤</span>
            <div>
              <div className="v2-row__label">Account</div>
              <div className="v2-row__desc">Manage your IGN and see your email</div>
            </div>
          </div>

          <div style={{ display: 'grid', gap: 14 }}>
            <Field label="Email" value={user.email} />
            <div>
              <div style={fieldLabel}>In-Game Name (IGN)</div>
              <div style={{ display: 'flex', gap: 8 }}>
                <input
                  type="text"
                  className="v2-input"
                  value={ignInput}
                  onChange={e => setIgnInput(e.target.value)}
                  placeholder="Enter your Among Us IGN…"
                  onKeyDown={e => { if (e.key === 'Enter') handleSave(); }}
                  style={{ flex: 1 }}
                />
                <button
                  type="button"
                  className="v2-btn v2-btn--primary"
                  onClick={handleSave}
                  disabled={!canSave}
                >
                  {saving ? 'Saving…' : 'Save'}
                </button>
              </div>
              <div style={{ fontSize: 12, color: 'var(--text-2)', marginTop: 8 }}>
                Must match your Among Us name exactly (case-sensitive)
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="v2-card" style={{ padding: '20px 22px', marginBottom: 14 }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14, marginBottom: 18, flexWrap: 'wrap' }}>
          <span style={{ fontSize: 22 }}>⬇️</span>
          <div style={{ flex: 1, minWidth: 220 }}>
            <div className="v2-row__label">AmongLR Desktop</div>
            <div className="v2-row__desc">Live overlay, post-game ELO breakdown, and quick launch for Among Us</div>
          </div>
          <a
            href={DOWNLOAD_URL}
            className="v2-btn v2-btn--primary"
            download="AmongLR-Setup.exe"
            style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center' }}
          >
            Download for Windows
          </a>
        </div>

        <div style={{ fontSize: 11, color: 'var(--text-3)', textTransform: 'uppercase', letterSpacing: '0.08em', fontFamily: "'Orbitron', sans-serif", marginBottom: 12 }}>
          Windows 10 or later
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: 10,
        }}>
          {FEATURES.map(f => (
            <div key={f.title} style={{
              background: 'var(--elevated)',
              border: '1px solid var(--border)',
              borderRadius: 10,
              padding: '12px 14px',
              display: 'flex',
              alignItems: 'flex-start',
              gap: 10,
            }}>
              <span style={{ fontSize: 20 }}>{f.icon}</span>
              <div>
                <div style={{ fontFamily: "'Orbitron', sans-serif", fontWeight: 700, fontSize: 12, color: 'var(--text)' }}>
                  {f.title}
                </div>
                <div style={{ fontSize: 12, color: 'var(--text-2)', marginTop: 2, lineHeight: 1.4 }}>
                  {f.desc}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {user && (
        <button
          type="button"
          className="v2-btn v2-btn--danger"
          onClick={onLogout}
          style={{ width: '100%', padding: 14 }}
        >
          Logout
        </button>
      )}
    </div>
  );
}

const fieldLabel = {
  fontFamily: "'Orbitron', sans-serif",
  fontSize: 10,
  fontWeight: 700,
  letterSpacing: '0.1em',
  color: 'var(--text-2)',
  textTransform: 'uppercase',
  marginBottom: 6,
};

function Field({ label, value }) {
  return (
    <div>
      <div style={fieldLabel}>{label}</div>
      <div style={{
        background: 'var(--elevated)',
        border: '1px solid var(--border)',
        borderRadius: 8,
        padding: '10px 12px',
        fontSize: 14,
        color: 'var(--text)',
        fontFamily: "'Rajdhani', sans-serif",
      }}>
        {value}
      </div>
    </div>
  );
}

export default SettingsPage;
